import React from 'react'
import Topnavigationbar from '../components/Topnavigationbar'
import img1 from '../images/News/img1.jpeg'
import img2 from '../images/News/img2.jpeg'
import img3 from '../images/News/img3.jpeg'
import img4 from '../images/News/img4.jpeg'
import img5 from '../images/News/img5.jpeg'
import img6 from '../images/News/img6.jpeg'
import img7 from '../images/News/img7.jpeg'
import img8 from '../images/News/img8.jpeg'
import img9 from '../images/News/img9.jpeg'
import img10 from '../images/News/img10.jpeg'
import img11 from '../images/News/img11.jpeg'
import img12 from '../images/News/img12.jpeg'
import img13 from '../images/News/img13.jpeg'
import img14 from '../images/News/img14.jpeg'
import img15 from '../images/News/img15.jpeg'
import img16 from '../images/News/img16.jpeg'
import img17 from '../images/News/img17.jpeg'
import img18 from '../images/News/img18.jpeg'
import img19 from '../images/News/img19.jpeg'
import img20 from '../images/News/img20.jpeg'
import arosha from '../images/News/arosha.jpeg';

//pohoya day photos
import pohoya_day_img1 from '../images/News/pohoya_day/01.jpg'
import pohoya_day_img2 from '../images/News/pohoya_day/02.jpg'
import pohoya_day_img3 from '../images/News/pohoya_day/03.jpg'
import pohoya_day_img4 from '../images/News/pohoya_day/04.jpg'
import pohoya_day_img5 from '../images/News/pohoya_day/05.jpg'
import pohoya_day_img6 from '../images/News/pohoya_day/06.jpg'
import pohoya_day_img7 from '../images/News/pohoya_day/07.jpg'
import pohoya_day_img8 from '../images/News/pohoya_day/08.jpg'
import pohoya_day_img10 from '../images/News/pohoya_day/10.jpg'
import pohoya_day_img11 from '../images/News/pohoya_day/11.jpg'
import pohoya_day_img132 from '../images/News/pohoya_day/13-2.jpg'
import pohoya_day_img14 from '../images/News/pohoya_day/14.jpg'
import pohoya_day_img15 from '../images/News/pohoya_day/15.jpg'
import pohoya_day_img16 from '../images/News/pohoya_day/16.jpg'
import pohoya_day_img17 from '../images/News/pohoya_day/17.jpg'
import pohoya_day_img18 from '../images/News/pohoya_day/18.jpg'
import pohoya_day_img19 from '../images/News/pohoya_day/19.jpg'
import pohoya_day_img20 from '../images/News/pohoya_day/20.jpg'
import pohoya_day_img21 from '../images/News/pohoya_day/21.jpg'
import pohoya_day_img22 from '../images/News/pohoya_day/22.jpg'
import pohoya_day_img23 from '../images/News/pohoya_day/23.jpg'
import pohoya_day_img24 from '../images/News/pohoya_day/24.jpg'
import pohoya_day_img25 from '../images/News/pohoya_day/25.jpg'
import pohoya_day_img26 from '../images/News/pohoya_day/26.jpg'
import pohoya_day_img27 from '../images/News/pohoya_day/27.jpg'
import pohoya_day_img28 from '../images/News/pohoya_day/28.jpg'
import pohoya_day_img29 from '../images/News/pohoya_day/29.jpg'
import pohoya_day_img30 from '../images/News/pohoya_day/30.jpg'
import pohoya_day_img31 from '../images/News/pohoya_day/31.jpg'
import pohoya_day_img32 from '../images/News/pohoya_day/32.jpg'
import pohoya_day_img33 from '../images/News/pohoya_day/33.jpg'
import pohoya_day_img34 from '../images/News/pohoya_day/34.jpg'





import Footer from '../components/Footer'

function News() {
  return (
    <div className="bg-gray-100 min-h-screen">
      <Topnavigationbar />
      <br></br>
      <br></br>
      <br></br>
      <br></br>
      <div className="max-w-3xl mx-auto bg-white p-6 rounded-lg shadow-lg mb-10 mt-10 text-center">
  <img
    src={arosha}
    alt="Arosha Athapaththu"
    className="mx-auto rounded-md w-60 h-auto mb-4"
  />
  <h2 className="text-xl font-semibold text-gray-800 mb-2">අරෝෂ අතපත්තු</h2>
  <p className="text-gray-700 text-lg leading-relaxed">
  හිටපු නාගරික මන්ත්‍රීවරයකු ලෙස වසර 20 ආසන්න කාලයක් වැලිකඩ ප්ලාසා සාප්පු සංකිර්ණයේ සියලු අඩුපාඩු වෙනුවෙන් අපට සහය
    දුන් අරෝෂ අතපත්තු සහෝදරයාට අප සැමගේ සහය ලබාදෙමු.
  </p>
</div>

      
      <div className="container mx-auto px-4 py-8">
        <br></br><br></br><br></br>
        <h1 className="text-2xl font-semibold text-gray-800 mb-6 text-center">2024/10/16 - News Article</h1>
        <p className="text-lg text-gray-700 mb-8 text-center">
          "මේ දින චතුරංග අබේසිංහ සහ අරෝෂ අතපත්තු සහෝදරයා මෙම වෙළෙද සංකීර්ණයේ චාරිකාවක් පැමිණි අතර අප සංගමය වෙත පවසා සිටියේ මෙම ගොඩනැගිල්ල කඩා ඉවත් කිරීම නවතා දමන බවත් සියලු නඩත්තු කටයුතු හැකි ඉක්මනින් යතා තත්වයට පත් කරන බවටත් පොරොන්දු විය."
        </p>

        {/* Image Gallery */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {/* Image 1 */}
          <div className="bg-white p-4 rounded-lg shadow-lg">
            <img src={img1} alt="News 1" className="w-full h-64 object-cover rounded-md mb-4" />
          </div>
          
          {/* Image 2 */}
          <div className="bg-white p-4 rounded-lg shadow-lg">
            <img src={img2} alt="News 2" className="w-full h-64 object-cover rounded-md mb-4" />
          </div>
          
          {/* Image 3 */}
          <div className="bg-white p-4 rounded-lg shadow-lg">
            <img src={img3} alt="News 3" className="w-full h-64 object-cover rounded-md mb-4" />
          </div>
          
          {/* Image 4 */}
          <div className="bg-white p-4 rounded-lg shadow-lg">
            <img src={img4} alt="News 4" className="w-full h-64 object-cover rounded-md mb-4" />
          </div>
          
          {/* Image 5 */}
          <div className="bg-white p-4 rounded-lg shadow-lg">
            <img src={img5} alt="News 5" className="w-full h-64 object-cover rounded-md mb-4" />
          </div>

          {/* Image 6 */}
          <div className="bg-white p-4 rounded-lg shadow-lg">
            <img src={img6} alt="News 6" className="w-full h-64 object-cover rounded-md mb-4" />
          </div>

          {/* Image 7 */}
          <div className="bg-white p-4 rounded-lg shadow-lg">
            <img src={img7} alt="News 7" className="w-full h-64 object-cover rounded-md mb-4" />
          </div>

          {/* Image 8 */}
          <div className="bg-white p-4 rounded-lg shadow-lg">
            <img src={img8} alt="News 8" className="w-full h-64 object-cover rounded-md mb-4" />
          </div>

          {/* Image 9 */}
          <div className="bg-white p-4 rounded-lg shadow-lg">
            <img src={img9} alt="News 9" className="w-full h-64 object-cover rounded-md mb-4" />
          </div>

          {/* Image 10 */}
          <div className="bg-white p-4 rounded-lg shadow-lg">
            <img src={img10} alt="News 10" className="w-full h-64 object-cover rounded-md mb-4" />
          </div>

          {/* Image 11 */}
          <div className="bg-white p-4 rounded-lg shadow-lg">
            <img src={img11} alt="News 11" className="w-full h-64 object-cover rounded-md mb-4" />
          </div>

          {/* Image 12 */}
          <div className="bg-white p-4 rounded-lg shadow-lg">
            <img src={img12} alt="News 12" className="w-full h-64 object-cover rounded-md mb-4" />
          </div>

          {/* Image 13 */}
          <div className="bg-white p-4 rounded-lg shadow-lg">
            <img src={img13} alt="News 13" className="w-full h-64 object-cover rounded-md mb-4" />
          </div>

          {/* Image 14 */}
          <div className="bg-white p-4 rounded-lg shadow-lg">
            <img src={img14} alt="News 14" className="w-full h-64 object-cover rounded-md mb-4" />
          </div>

          {/* Image 15 */}
          <div className="bg-white p-4 rounded-lg shadow-lg">
            <img src={img15} alt="News 15" className="w-full h-64 object-cover rounded-md mb-4" />
          </div>

          {/* Image 16 */}
          <div className="bg-white p-4 rounded-lg shadow-lg">
            <img src={img16} alt="News 16" className="w-full h-64 object-cover rounded-md mb-4" />
          </div>

          {/* Image 17 */}
          <div className="bg-white p-4 rounded-lg shadow-lg">
            <img src={img17} alt="News 17" className="w-full h-64 object-cover rounded-md mb-4" />
          </div>

          {/* Image 18 */}
          <div className="bg-white p-4 rounded-lg shadow-lg">
            <img src={img18} alt="News 18" className="w-full h-64 object-cover rounded-md mb-4" />
          </div>

          {/* Image 19 */}
          <div className="bg-white p-4 rounded-lg shadow-lg">
            <img src={img19} alt="News 19" className="w-full h-64 object-cover rounded-md mb-4" />
          </div>

          {/* Image 20 */}
          <div className="bg-white p-4 rounded-lg shadow-lg">
            <img src={img20} alt="News 20" className="w-full h-64 object-cover rounded-md mb-4" />
          </div>
        </div>

        <br></br><br></br><br></br>
        <h1 className="text-2xl font-semibold text-gray-800 mb-6 text-center">2025 ජුනි මස පොසොන් පොහෝ දින වෙනුවෙන් පවත්වන ලද සීනි සම්බෝල පාන් දන්සල </h1>

        {/* Image Gallery poson day */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {/* Image 1 */}
          <div className="bg-white p-4 rounded-lg shadow-lg">
            <img src={pohoya_day_img1} alt="News 1" className="w-full h-64 object-cover rounded-md mb-4" />
          </div>
          
          {/* Image 2 */}
          <div className="bg-white p-4 rounded-lg shadow-lg">
            <img src={pohoya_day_img2} alt="News 2" className="w-full h-64 object-cover rounded-md mb-4" />
          </div>
          
          {/* Image 3 */}
          <div className="bg-white p-4 rounded-lg shadow-lg">
            <img src={pohoya_day_img3} alt="News 3" className="w-full h-64 object-cover rounded-md mb-4" />
          </div>

          {/* Image 4 */}
          <div className="bg-white p-4 rounded-lg shadow-lg">
            <img src={pohoya_day_img4} alt="News 3" className="w-full h-64 object-cover rounded-md mb-4" />
          </div>

          {/* Image 5 */}
          <div className="bg-white p-4 rounded-lg shadow-lg">
            <img src={pohoya_day_img5} alt="News 3" className="w-full h-64 object-cover rounded-md mb-4" />
          </div>

          {/* Image 6 */}
          <div className="bg-white p-4 rounded-lg shadow-lg">
            <img src={pohoya_day_img6} alt="News 3" className="w-full h-64 object-cover rounded-md mb-4" />
          </div>

          {/* Image 7 */}
          <div className="bg-white p-4 rounded-lg shadow-lg">
            <img src={pohoya_day_img7} alt="News 3" className="w-full h-64 object-cover rounded-md mb-4" />
          </div>

          {/* Image 8 */}
          <div className="bg-white p-4 rounded-lg shadow-lg">
            <img src={pohoya_day_img8} alt="News 3" className="w-full h-64 object-cover rounded-md mb-4" />
          </div>

          {/* Image 10 */}
          <div className="bg-white p-4 rounded-lg shadow-lg">
            <img src={pohoya_day_img10} alt="News 3" className="w-full h-64 object-cover rounded-md mb-4" />
          </div>

          {/* Image 11 */}
          <div className="bg-white p-4 rounded-lg shadow-lg">
            <img src={pohoya_day_img11} alt="News 3" className="w-full h-64 object-cover rounded-md mb-4" />
          </div>

          {/* Image 13-2 */}
          <div className="bg-white p-4 rounded-lg shadow-lg">
            <img src={pohoya_day_img132} alt="News 3" className="w-full h-64 object-cover rounded-md mb-4" />
          </div>

          {/* Image 14 */}
          <div className="bg-white p-4 rounded-lg shadow-lg">
            <img src={pohoya_day_img14} alt="News 3" className="w-full h-64 object-cover rounded-md mb-4" />
          </div>

          {/* Image 15 */}
          <div className="bg-white p-4 rounded-lg shadow-lg">
            <img src={pohoya_day_img15} alt="News 3" className="w-full h-64 object-cover rounded-md mb-4" />
          </div>

          {/* Image 16 */}
          <div className="bg-white p-4 rounded-lg shadow-lg">
            <img src={pohoya_day_img16} alt="News 3" className="w-full h-64 object-cover rounded-md mb-4" />
          </div>

          {/* Image 17 */}
          <div className="bg-white p-4 rounded-lg shadow-lg">
            <img src={pohoya_day_img17} alt="News 3" className="w-full h-64 object-cover rounded-md mb-4" />
          </div>
          
          {/* Image 18 */}
          <div className="bg-white p-4 rounded-lg shadow-lg">
            <img src={pohoya_day_img18} alt="News 3" className="w-full h-64 object-cover rounded-md mb-4" />
          </div>

          {/* Image 19 */}
          <div className="bg-white p-4 rounded-lg shadow-lg">
            <img src={pohoya_day_img19} alt="News 3" className="w-full h-64 object-cover rounded-md mb-4" />
          </div>

          {/* Image 20 */}
          <div className="bg-white p-4 rounded-lg shadow-lg">
            <img src={pohoya_day_img20} alt="News 3" className="w-full h-64 object-cover rounded-md mb-4" />
          </div>

          {/* Image 21 */}
          <div className="bg-white p-4 rounded-lg shadow-lg">
            <img src={pohoya_day_img21} alt="News 3" className="w-full h-64 object-cover rounded-md mb-4" />
          </div>

          {/* Image 22 */}
          <div className="bg-white p-4 rounded-lg shadow-lg">
            <img src={pohoya_day_img22} alt="News 3" className="w-full h-64 object-cover rounded-md mb-4" />
          </div>

          {/* Image 23 */}
          <div className="bg-white p-4 rounded-lg shadow-lg">
            <img src={pohoya_day_img23} alt="News 3" className="w-full h-64 object-cover rounded-md mb-4" />
          </div>

          {/* Image 24 */}
          <div className="bg-white p-4 rounded-lg shadow-lg">
            <img src={pohoya_day_img24} alt="News 3" className="w-full h-64 object-cover rounded-md mb-4" />
          </div>

          {/* Image 25 */}
          <div className="bg-white p-4 rounded-lg shadow-lg">
            <img src={pohoya_day_img25} alt="News 3" className="w-full h-64 object-cover rounded-md mb-4" />
          </div>

          {/* Image 26 */}
          <div className="bg-white p-4 rounded-lg shadow-lg">
            <img src={pohoya_day_img26} alt="News 3" className="w-full h-64 object-cover rounded-md mb-4" />
          </div>

          {/* Image 27 */}
          <div className="bg-white p-4 rounded-lg shadow-lg">
            <img src={pohoya_day_img27} alt="News 3" className="w-full h-64 object-cover rounded-md mb-4" />
          </div>

          {/* Image 28 */}
          <div className="bg-white p-4 rounded-lg shadow-lg">
            <img src={pohoya_day_img28} alt="News 3" className="w-full h-64 object-cover rounded-md mb-4" />
          </div>

          {/* Image 29 */}
          <div className="bg-white p-4 rounded-lg shadow-lg">
            <img src={pohoya_day_img29} alt="News 3" className="w-full h-64 object-cover rounded-md mb-4" />
          </div>

           {/* Image 30 */}
          <div className="bg-white p-4 rounded-lg shadow-lg">
            <img src={pohoya_day_img30} alt="News 3" className="w-full h-64 object-cover rounded-md mb-4" />
          </div>

           {/* Image 31 */}
          <div className="bg-white p-4 rounded-lg shadow-lg">
            <img src={pohoya_day_img31} alt="News 3" className="w-full h-64 object-cover rounded-md mb-4" />
          </div>

          {/* Image 32 */}
          <div className="bg-white p-4 rounded-lg shadow-lg">
            <img src={pohoya_day_img32} alt="News 3" className="w-full h-64 object-cover rounded-md mb-4" />
          </div>

          {/* Image 33 */}
          <div className="bg-white p-4 rounded-lg shadow-lg">
            <img src={pohoya_day_img33} alt="News 3" className="w-full h-64 object-cover rounded-md mb-4" />
          </div>

           {/* Image 34 */}
          <div className="bg-white p-4 rounded-lg shadow-lg">
            <img src={pohoya_day_img34} alt="News 3" className="w-full h-64 object-cover rounded-md mb-4" />
          </div>
        </div>
      </div>
      <Footer/>
    </div>
  );
  
}

export default News